import { render, staticRenderFns } from "./TypesWork.vue?vue&type=template&id=5aa3d57c&scoped=true&"
import script from "./TypesWork.vue?vue&type=script&lang=js&"
export * from "./TypesWork.vue?vue&type=script&lang=js&"
import style0 from "./TypesWork.vue?vue&type=style&index=0&id=5aa3d57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3d57c",
  null
  
)

export default component.exports